import { render, staticRenderFns } from "./MarketplacePatentsViewAll.vue?vue&type=template&id=31817e8e&scoped=true"
import script from "./MarketplacePatentsViewAll.vue?vue&type=script&lang=js"
export * from "./MarketplacePatentsViewAll.vue?vue&type=script&lang=js"
import style0 from "./MarketplacePatentsViewAll.vue?vue&type=style&index=0&id=31817e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31817e8e",
  null
  
)

export default component.exports